import React, { useContext } from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import MyContext from "../context/MyContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { Button, Badge } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import { Link, NavLink, useHistory } from "react-router-dom";
import { logOutUser } from "../helpers/apiCalls";

const MobileMenu = ({ positionRight }) => {
  const history = useHistory();
  const context = useContext(MyContext);
  const {
    user,
    cart,
    setUser,
    isAdmin,
    setIsAdmin,
    isLogged,
    setIsLogged,
    categories,
    category,
    setCategory,
    sort,
    setSort,
    search,
    setSearch,
    setAuthIsDone,
    callback,
    setCallback,
    openState,
    setOpenState,
    setPositionRight
  } = context;

  const goTo = () => {
    setCallback(!callback);
    history.push("/dashboard");
  };

  const handleLogout = () => {
    setIsLogged(false);
    setIsAdmin(false);
    setUser();
    setAuthIsDone(false);
    logOutUser();
    history.push("/");
  };

  const handleCategory = (e) => {
    setCategory(e.target.value);
    setSearch("");
  };

  const handleState = ()=>{
    setOpenState(!openState)
    setPositionRight(0)
  }

  return (
    <div className="navbar-content-two" style={{ right: `${positionRight}px` }}>
      <ListGroup>
        <ListGroupItem className="bg-color">
          <input
            type="text"
            value={search}
            placeholder="Enter your search!"
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
          />
          <select name="category" value={category} onChange={handleCategory}>
            <option value="">All Products</option>
            {categories.map((category) => (
              <option value={"category=" + category._id} key={category._id}>
                {category.name}
              </option>
            ))}
          </select>
          <select value={sort} onChange={(e) => setSort(e.target.value)}>
            <option value="">Newest</option>
            <option value="sort=oldest">Oldest</option>
            <option value="sort=-sold">Best sales</option>
            <option value="sort=-price">Price: Hight-Low</option>
            <option value="sort=price">Price: Low-Hight</option>
          </select>
          <div className="user">
            <Link to="/" onClick={handleState}>{isAdmin ? "Products" : "Shop"}</Link>
            {isLogged && !isAdmin && (
              <Link to="/orderhistory" style={{textAlign: "right"}} onClick={handleState}>Order History</Link>
            )}
            {user ? (
              <>
                {isAdmin ? (
                  <h2>{user.fullName}</h2>
                ) : (
                  <>
                    {user.billAddress ? (
                      <Link onClick={handleState}>
                        <button type="submit" onClick={goTo}>
                          {user.fullName}
                        </button>
                      </Link>
                    ) : (
                      <Link to="/add-bill-address" onClick={handleState}>
                        <h2>{user.fullName}</h2>
                      </Link>
                    )}
                  </>
                )}
                <Link style={{textAlign: "right", padding: "10px"}} onClick={handleState}>
                  <FontAwesomeIcon                  
                    title="Logout"
                    onClick={handleLogout}
                    icon={faSignOutAlt}
                  />
                </Link>
              </>
            ) : (
              <Link to="/login" onClick={handleState}>
                <Avatar />
              </Link>
            )}
            {!user || isAdmin || (
              <Button
                component={NavLink}
                to="/cart"
                aria-label="Show Cart Item"
                onClick={handleState}
              >
                <Badge badgeContent={cart.length} color="secondary" onClick={handleState}>
                  <LocalMallIcon />
                </Badge>
              </Button>
            )}
          </div>
        </ListGroupItem>
      </ListGroup>
    </div>
  );
};

export default MobileMenu;
